<template>
  <div class="products-management-page">
        <marketplace-card-slider v-model="selectedMarketplace" class="pa-3"/>
    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      class="mx-2 my-4 "
      grow
    >
      <template #staticItems>
        <!-- تب اول:مارکت پلیس فعال -->
        <v-tab-item>
          <marketplace-listings-active :store_id="selectedMarketplace?.store_id" :key="`${selectedMarketplace?.store_id}-2`"/>
        </v-tab-item>

        <!-- تب دوم: مارکت پلیس غیرفعال -->
        <v-tab-item>
          
          <marketplace-listings-deactive :store_id="selectedMarketplace?.store_id" :key="`${selectedMarketplace?.store_id}-1`"/>
        </v-tab-item>

      </template>
    </custom-tabs>
  </div>
</template>

<script>
import MarketplaceCardSlider from "../../../components/MarketplaceCardSlider.vue";
import MarketplaceListingsActive from "./MarketplaceListingsActive.vue";
import MarketplaceListingsDeactive from "./MarketplaceListingsDeactive.vue";

export default {
  name: "MarketplaceListings",
  components: {
    MarketplaceListingsActive,
    MarketplaceListingsDeactive,
    MarketplaceCardSlider
  },
  
  data() {
    return {
      selectedMarketplace:null,
      activeTab: 0,
      tabs: [
        {
          text: "مارکت پلیس فعال",
          icon: "store-check-outline",
        },
        {
          text: "مارکت پلیس غیرفعال",
          icon: "store-off-outline",
        },
         
      ],
    };
  },
};
</script>
